import React from 'react';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import CaptionValue from '../../../../Components/CaptionValue/CaptionValue';

const DynamicDataWidget = function ProductInfoWidget({ data: metadata }) {
  return (metadata && (<Box sx={{ flexGrow: 1, padding: '16px' }}>
    <Typography variant="h6" sx={{
      mb: "8px"
    }}>
      {metadata.title}
    </Typography>
    <Grid
      container
      direction={metadata.direction}
      columns={metadata.columns}
      columnSpacing={metadata.columnSpacing}
      rowSpacing={metadata.rowSpacing}
    >
      {metadata?.features?.map(({ size, label, value }, index) =>
        label ? (
          <Grid key={`${String(index)}`} size={{ xs: size }}>
            <CaptionValue
              captionColor="primary"
              captionStyle={{
                fontWeight: 'bold',
                textTransform: 'uppercase',
              }}
              caption={label}
              value={value}
            />
          </Grid>
        ) : (
          <Grid key={`${String(index)}`} size={{ xs: size }}>
            <div />
          </Grid>
        )
      )}
    </Grid>
  </Box>));
};

DynamicDataWidget.propTypes = {
  data: PropTypes.object.isRequired,
};
export default DynamicDataWidget;
